/**
 * Botao de recolher a sidebar - visual novo.
 *
 * Era `IconButtonAnimate` do MUI com um SVG de duas setas. Virou um botao de 28px
 * com `«`/`»`, que diz para que lado a barra vai - a seta dupla anterior girava
 * 180 graus e, sem rotulo, nao dizia nada.
 *
 * O `title` muda junto com o estado: "Recolher menu" / "Expandir menu". Botao de
 * icone sem nome e adivinhacao para quem usa leitor de tela.
 */
export default function CollapseButton({ onToggleCollapse, collapseClick }) {
  const rotulo = collapseClick ? 'Expandir menu' : 'Recolher menu';

  return (
    <button
      type="button"
      onClick={onToggleCollapse}
      title={rotulo}
      aria-label={rotulo}
      // Este botao fica no topo da sidebar, que agora e a faixa da cor primary:
      // `border-line` + `text-muted-foreground` sao cinzas de superficie clara e
      // ali ficavam quase invisiveis. Derivados de `primary-foreground` funcionam
      // em qualquer preset e nos dois temas.
      className="grid h-7 w-7 place-items-center rounded-md border border-primary-foreground/40 text-[12px] font-bold text-primary-foreground transition-colors hover:bg-primary-foreground/10"
    >
      {collapseClick ? '»' : '«'}
    </button>
  );
}
